import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const activityTasksRoutes: RouteObject[] = [
  {
    path: ROUTES.ACTIVITY_TASKS.LIST,
    element: (
      <PrivateRoute>
        <Pages.ActivityTasks />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ACTIVITY_TASKS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddActivityTasks />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ACTIVITY_TASKS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditActivityTasks />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ACTIVITY_TASKS.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewActivityTasks />
      </PrivateRoute>
    ),
  },
]

export default activityTasksRoutes
